




























































































































































































import Vue from 'vue';
import NpCheckbox from '@/components/NpCheckbox.vue';
import NpInput from '@/components/NpInput.vue';
import NpSelect from '@/components/NpSelect.vue';
import FormInput from '@/components/ui/FormInput.vue';
import FormPasswordInput from '@/components/ui/FormPasswordInput.vue';
import Customer from '@/models/Customer';
import Group from '@/models/Group';
import RegistrationType from '@/models/RegistrationType';
import { arrayOrEmpty, getOrFalse } from '@/utilities/helpers';
import states from '@/utilities/states';
import ReservationFields from '@/models/ReservationFields';

export default Vue.extend({
	name: 'PersonalForm',
	inject: ['$validator'],

	components: {
		FormInput,
		FormPasswordInput,
		NpInput,
		NpCheckbox,
		NpSelect,
	},

	props: {
		formSettings: {} as () => ReturnType<typeof RegistrationType | typeof ReservationFields>,
		type: String,
		value: { type: Object, default() { return {}; } },
	},

	data() {
		return {
			states: states as any,
			loading: false,
			showConfirm: true,
		};
	},

	computed: {
		model: {
			get(): Customer | Group {
				return this.value;
			},
			set(value: Customer | Group) {
				this.$emit('input', value);
			},
		},
		corporateCompany(): any {
			return this.$store.getters['location/corporateCompany'];
		},

		hasNewsletters(): boolean {
			return getOrFalse('settings.mailchimp_newsletter_audience', this.location);
		},

		isLoggedIn(): boolean {
			return this.$store.getters.isLoggedIn;
		},

		allowCustomerEdit(): boolean {
			const settings = this.$store.getters['location/settings'];
			return settings.allow_registration_edit || false;
		},

		location(): Locations.Location {
			return this.$store.getters['location/location'];
		},

		primaryPhone(): string {
			return this.location.settings.primary_phone_description || 'Cell Phone';
		},

		secondaryPhone(): string {
			return this.location.settings.secondary_phone_description || 'Work Phone';
		},

		showSubscriptionField(): boolean {
			if (!this.hasNewsletters) {
				return false;
			}

			return true;
		},

		default_email_receipt(): boolean {
			if (this.location.settings.uncheck_default_email_receipts_checkbox) {
				this.model.email_receipt = false;
				return false;
			}
			return true;
		},
		newsLetterText(): string {
			let value = '';
			if (this.showSubscriptionField) {
				value = 'I would like to opt-in for special offers and promotions';
			}
			if (this.location.settings.news_letter_text) {
				value = this.location.settings.news_letter_text;
			}
			return value;
		},
	},

	watch: {
		location(value, oldValue) {
			if (value.code !== oldValue.code) {
				this.checkCorporateCompany();
			}
		},
	},

	created() {
		this.$set(this, 'model', this.value);

		if (this.model.email && !this.allowCustomerEdit) {
			this.showConfirm = false;
		}

		if (this.type === 'register') {
			this.model.email_receipt = true;
		}

		if (this.showSubscriptionField && this.type !== 'profile') {
			this.model.newsletter_opt_in = true;
		}

		this.checkCorporateCompany();
	},

	methods: {
		checkCorporateCompany() {
			if (this.corporateCompany && this.corporateCompany.company_id) {
				this.$set(this.model, 'company', +this.corporateCompany.company_id);
			}
		},
		validateEmail() {
			this.$emit('validateemail');
		},
		typeIncludes(...types: string[]): boolean {
			return arrayOrEmpty(types).includes(this.type);
		},
	},
});
